import { useState, useEffect } from 'react'
import './Scoreboard.css'
import BarChart from './BarChart';
import ScoreboardTable from './ScoreboardTable'
import TableSolve from './TableSolve'
import { Paper, TableBody, makeStyles, Modal,  TableCell, TableRow, Button, IconButton } from '@material-ui/core';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
const Scoreboard = () => {
  const useStyles = makeStyles(theme => ({
    pageContent: {
      margin: theme.spacing(5),
      padding: theme.spacing(3)
    },
    searchInput: {
      width: '75%'
    },
    modalSolve: {
      position: 'absolute',
      width: '50%',
      backgroundColor: 'white',
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      //padding: '16px 32px 24px',
      padding: theme.spacing(2, 4, 3, 4),
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  }))
  const classes = useStyles();
  const [records, setRecords] = useState([])
  const [recordsSolves, setRecordsSolves] = useState([])
  const headCells = [
    { id: 'lugar', label: 'Lugar' },
    { id: 'equipo', label: 'Equipo' },
    { id: 'puntaje', label: 'Puntaje' },
  ]
  const headCellsSolves = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'puntos', label: 'Puntos' },
    { id: 'resuelto', label: 'Resuelto' },
  ]
  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting
  } = ScoreboardTable(records, headCells);
  const {
    TblContainer: TblContainer2,
    TblHead: TblHead2,
    TblPagination: TblPagination2,
    recordsAfterPagingAndSorting: recordsAfterPagingAndSorting2
  } = TableSolve(recordsSolves, headCellsSolves);

  const cookies = new Cookies();
  const userToken = cookies.get('tokenCTF');
  const [modalSolves, setModalSolves] = useState(false);
  const history = useHistory();

  //TABLE
  useEffect(() => {
    axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/scoreboard/getScores`, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setRecords(response.data);
      }
    })
  }, []);
  const openCloseModal = () => {
    setModalSolves(!modalSolves);
  }

  const onClickTeam = (id) => {
    axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/scoreboard/getSolvesTeam`, {
      team_id: id
    }, {
      headers: { 'Authorization': userToken }
    }).then((response) => {
      if (response.data.noAuth) {
        cookies.remove('tokenCTF', { path: '/' });
        history.push('/login');
      }
      else {
        setRecordsSolves(response.data);
        openCloseModal();
      }

    })
  }
  return (
    <div className="scoreboard">

      <div className="score-chart">
        <h1>TOP 10</h1>
        <BarChart />
      </div>
      <div className="score-table">
        <Paper className="tablePaddingMargin">
          <TblContainer>
            <TblHead />
            <TableBody>
              {
                recordsAfterPagingAndSorting().map((item) => (

                  <TableRow key={item.place} onClick={(e) => { onClickTeam(item.team_id) }}>
                    <TableCell >{item.place}</TableCell>
                    <TableCell >{item.name}</TableCell>
                    <TableCell >{item.score}</TableCell>


                  </TableRow>
                ))
              }

            </TableBody>
          </TblContainer>
          <TblPagination />
        </Paper>
      </div>
      <Modal open={modalSolves} onClose={openCloseModal}>
        <div className="modalSolve">
          <Paper className="paperStyle">
            <TblContainer2>
              <TblHead2 />
              <TableBody>
                {
                  recordsAfterPagingAndSorting2().map(item => (
                    <TableRow key={item.team_id} >
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.value}</TableCell>
                      <TableCell>{item.fecha}</TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </TblContainer2>
            <TblPagination2 />
          </Paper>
          <div className="divStyling" align="right">
          <Button variant='outlined' color='secondary' onClick={openCloseModal} >Cerrar</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
export default Scoreboard;

